import { action, computed, observable } from 'mobx'

/**
 * Tracks whether a fetch is refetching content that has already loaded, so
 * the view keeps showing that content instead of a loading state. The
 * task-based counterpart of `InfiniteScrollProvider.isRevalidating`.
 */
export class Revalidation {
  @observable private accessor _hasLoaded = false

  /**
   * Constructor.
   *
   * @param _isPending whether the fetch is in flight, usually
   * `() => this.fetch.pending`.
   */
  constructor(private readonly _isPending: () => boolean) {}

  /**
   * Whether the fetch is in flight after a previous one completed.
   */
  @computed
  get isRevalidating() {
    return this._isPending() && this._hasLoaded
  }

  /**
   * Marks the content as loaded, call when a fetch completes.
   */
  @action.bound
  markLoaded() {
    this._hasLoaded = true
  }

  /**
   * Forgets the loaded content, so the next fetch shows a loading state.
   */
  @action.bound
  reset() {
    this._hasLoaded = false
  }
}
